// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Color = require("../Chip.Model.Color/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Show = require("../Data.Show/index.js");
var SkiSkates = (function () {
    function SkiSkates() {

    };
    SkiSkates.value = new SkiSkates();
    return SkiSkates;
})();
var SuctionBoots = (function () {
    function SuctionBoots() {

    };
    SuctionBoots.value = new SuctionBoots();
    return SuctionBoots;
})();
var FireBoots = (function () {
    function FireBoots() {

    };
    FireBoots.value = new FireBoots();
    return FireBoots;
})();
var Flippers = (function () {
    function Flippers() {

    };
    Flippers.value = new Flippers();
    return Flippers;
})();
var Key = (function () {
    function Key(value0) {
        this.value0 = value0;
    };
    Key.create = function (value0) {
        return new Key(value0);
    };
    return Key;
})();
var showItem = new Data_Show.Show(function (v) {
    if (v instanceof SkiSkates) {
        return "S";
    };
    if (v instanceof SuctionBoots) {
        return "U";
    };
    if (v instanceof FireBoots) {
        return "I";
    };
    if (v instanceof Flippers) {
        return "F";
    };
    if (v instanceof Key) {
        if (v.value0 instanceof Chip_Model_Color.Red) {
            return "r";
        };
        if (v.value0 instanceof Chip_Model_Color.Cyan) {
            return "c";
        };
        if (v.value0 instanceof Chip_Model_Color.Yellow) {
            return "y";
        };
        if (v.value0 instanceof Chip_Model_Color.Green) {
            return "g";
        };
        throw new Error("Failed pattern match at Chip.Model.Item (line 25, column 18 - line 29, column 19): " + [ v.value0.constructor.name ]);
    };
    throw new Error("Failed pattern match at Chip.Model.Item (line 20, column 10 - line 29, column 19): " + [ v.constructor.name ]);
});
var eqItem = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof SkiSkates && y instanceof SkiSkates) {
            return true;
        };
        if (x instanceof SuctionBoots && y instanceof SuctionBoots) {
            return true;
        };
        if (x instanceof FireBoots && y instanceof FireBoots) {
            return true;
        };
        if (x instanceof Flippers && y instanceof Flippers) {
            return true;
        };
        if (x instanceof Key && y instanceof Key) {
            return Data_Eq.eq(Chip_Model_Color.eqColor)(x.value0)(y.value0);
        };
        return false;
    };
});
module.exports = {
    SkiSkates: SkiSkates,
    SuctionBoots: SuctionBoots,
    FireBoots: FireBoots,
    Flippers: Flippers,
    Key: Key,
    eqItem: eqItem,
    showItem: showItem
};
